import {
    ArrowPathIcon,
    CloudArrowUpIcon,
    Cog6ToothIcon,
    FingerPrintIcon,
    LockClosedIcon,
    ServerIcon,
} from '@heroicons/react/20/solid'

const features = [
    {
        name: 'Paid Ads.',
        description: 'Boost the impact and lower costs by syncing paid ads with your SEO strategy from the start.',
        icon: CloudArrowUpIcon,
    },
    {
        name: 'Affiliate Selling.',
        description: 'Onboard 4 active affiliates and set the commission for sales generated by your affiliate network.',
        icon: LockClosedIcon,
    },
    {
        name: 'Social Media.',
        description: 'Ac tincidunt sapien vehicula erat auctor pellentesque rhoncus voluptas blanditiis et.',
        icon: ArrowPathIcon,
    },
    {
        name: 'Online Marketing.',
        description: 'Iure sed ab. Aperiam optio placeat dolor facere. Officiis pariatur eveniet atque et dolor.',
        icon: FingerPrintIcon,
    },
]

export default function FirefoxGridView() {
    return (
        <div className="">
            <div className="mx-auto px-6 lg:px-20">
                <dl className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 text-base/7 text-gray-400 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-4 lg:gap-x-8">
                    {features.map((feature) => (
                        <div key={feature.name} className="relative px-6 bg-gray-700 py-20 rounded-xl" style={{backgroundColor: "#333336"}}>
                            <dt className="inline font-semibold text-white">
                                <div className="absolute top-8 left-8 size-5 text-black text-sm">

                                    <div className="flex">
                                        <div className="flex px-2 py-1 pr-4 items-center justify-center rounded-full bg-red-300">
                                            <div className="mr-4" style={{width: '16px'}}>
                                                <feature.icon aria-hidden="true"
                                                              className=""/>
                                            </div>
                                            Security
                                        </div>
                                    </div>
                                </div>
                                <h4 className="font-semibold custom-font">
                                    {feature.name}
                                </h4>
                            </dt>
                            {' '}
                            <div className="inline text-white">{feature.description}</div>
                        </div>
                    ))}
                </dl>
            </div>
        </div>
    )
}
